import React from 'react';

const colors = ['#00CEEE', '#009995', '#00E3E2', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981', '#EF4444'];

function getColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return colors[Math.abs(hash) % colors.length];
}

function getInitials(name) {
  return name.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase();
}

export default function Avatar({ name = '', size = 36, src, style }) {
  if (src) return (
    <img src={src} alt={name} style={{
      width: size, height: size, borderRadius: '50%', objectFit: 'cover',
      border: '2px solid #E2E8F0',
      ...style,
    }} />
  );
  const bg = getColor(name || 'A');
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: `linear-gradient(135deg, ${bg}, ${bg}dd)`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: '#fff',
      fontWeight: 700,
      fontSize: size * 0.36,
      flexShrink: 0,
      letterSpacing: '0.02em',
      boxShadow: `0 2px 8px ${bg}33`,
      ...style,
    }}>
      {getInitials(name || '?')}
    </div>
  );
}
